module.exports = __webpack_public_path__ + "static/one-b964f60405a134a1e046aff7cbd7504c.png";